import _ from 'lodash';

import TrainTime from '../lib/TrainTime';

function makePropType (fn) {
    fn.isRequired = function (props, name, ...rest) {
        if (_.isNil(props[name])) {
            return new Error(`${name} is a required prop`);
        }
        return fn(props, name, ...rest);
    };
    return fn;
}

export default {
    isMoment: makePropType((props, name) => {
        if (props[name] && !TrainTime.isMoment(props[name])) {
            return new Error(`${name} must be a moment.js date instance`);
        }
        return null;
    }),
    isTrainTime: makePropType((props, name) => {
        if (props[name] && !TrainTime.isTrainTime(props[name])) {
            return new Error(`${name} must be a moment.js date instance in the correct timezone`);
        }
        return null;
    }),
    isDuration: makePropType((props, name) => {
        if (props[name] && !TrainTime.isDuration(props[name])) {
            return new Error(`${name} must be a moment.js duration`);
        }
        return null;
    })
};



// WEBPACK FOOTER //
// ./src/helpers/MomentPropTypes.js